import {
  Typography,
  Table,
  Tag,
  Col,
  Popover,
  Menu,
  Spin,
  Modal,
  Input,
  Tooltip,
} from "antd";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  Images,
} from "../../global";
import {
  Row,
  Icon,
  Text,
  View,
  Button,
  LoadingIcon,
  Graph,
  Alert,
} from "../../Components";
import { useEffect, useState, useRef } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { useNavigate, useMatch } from "react-router-dom";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useCookies } from "react-cookie";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { ArrowLeftOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { ReactComponent as optionsIcon } from "../../Assets/SVG/Options.svg";
import { ReactComponent as backIcon } from "../../Assets/SVG/Back.svg";
import { ReactComponent as trashIcon } from "../../Assets/SVG/Trash_Small.svg";
import {
  ToolTypes,
  getLiveGraphData,
  addGraphLiveData,
  checkSubscriptionLevel,
  getUser,
  updateUser,
  getUserDeleteToken,
  deleteUser,
  getRecipientShares,
  updateRecipient,
  cancelSubscription,
  checkPayMethod,
  createPayMethod,
  setDefaultPM,
  deletePayMethod,
  retrieveInvoices,
  createSubscription,
} from "../../API";
import {
  THP_ENABLED_ARRAY,
  THP_CHANNEL_ICONS,
  THP_DEFAULT_Y_AXIS,
  THP_CH_ENUM,
  THP_ENABLED_CHANNELS,
} from "../../Tools/THP";
import HelperService from "../../Helpers/HelperService";
import { ResponsiveLine } from "@nivo/line";
import { Storage, Auth, Amplify } from "aws-amplify";
import ReportColumns from "../../Components/Column/ReportColumns";
import _, { set } from "lodash";
import { Paper, Space, Loader, Center } from "@mantine/core";

const monthlyPlan = "price_1Ne0cEGj4W74K3goX912tX3g";
const yearlyPlan = "price_1Ne0cEGj4W74K3goWgpXNg4f";
const invoiceColumns = [
  {
    title: "Date",
    dataIndex: "created",
    key: "created",
    render: (date) => (
      <Text as={"small"} color={"darkGrey"}>
        {new Date(date * 1000).toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
        })}
      </Text>
    ),
  },
  {
    title: "Invoice Number",
    dataIndex: "number",
    key: "number",
    render: (number) => (
      <Text as={"small"} color={"darkGrey"}>
        {number}
      </Text>
    ),
  },
  {
    title: "Amount",
    dataIndex: "total",
    key: "total",
    render: (total) => (
      <Text as={"small"} color={"darkGrey"}>
        {"$" + total / 100}
      </Text>
    ),
  },
  {
    title: "Method",
    dataIndex: "id",
    key: "id",
    render: () => (
      <Text as={"small"} color={"darkGrey"}>
        {"Credit Card"}
      </Text>
    ),
  },
  // {
  // title: '',
  // dataIndex: 'id',
  // key: 'id',
  // render: () => <Icon svg={optionsIcon} color={Colors.darkGrey} size='sm' />,
  // }
];
let tempDefaultPM = null;
function Reports() {
  const navigate = useNavigate();
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const [subscriptionLevel, setSubscriptionLevel] = useState(null);
  const [invoices, setInvoices] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [checkSubscription, setCheckSubscription] = useState(false);
  const [value, setValue] = useState("Yearly");
  const [defaultPayment, setDefaultPayment] = useState(null);
  const [subNav, setSubNav] = useState("subscription");
  const [cancelLoading, setCancelLoading] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [deleteCardLoading, setDeleteCardLoading] = useState(false);
  const [showDeleteCard, setShowDeleteCard] = useState(false);
  const [makeDefaultLoading, setMakeDefaultLoading] = useState(false);
  const [showCardInput, setShowCardInput] = useState(false);
  const [saveCardLoading, setSaveCardLoading] = useState(false);
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const [showPaymentError, setShowPaymentError] = useState(false);
  const billingRate = ["Yearly", "Monthly"];
  const [tableHeight, setTableHeight] = useState();
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cardExpiry, setCardExpiry] = useState("");
  const [cardCode, setCardCode] = useState("");
  const [cardZip, setCardZip] = useState("");
  const [cardErrors, setCardErrors] = useState({
    name: "",
    number: "",
    expiry: "",
    code: "",
    zip: "",
  });
  const [cardCreateError, setCardCreateError] = useState("");
  const [open, setOpen] = useState(false);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const cvcRef = useRef();
  if (subscriptionLevel == null && !subscriptionLoading) {
    setSubscriptionLoading(true);
  }
  const handleCardDisplay = () => {
    const rawText = [...cardNumber.split(" ").join("")]; // Remove old space
    const creditCard = []; // Create card as array
    rawText.forEach((t, i) => {
      if (cardNumber.startsWith(3)) {
        //Amex
        if (i == 4 || i == 10) creditCard.push(" ");
      } else if (i % 4 === 0 && i !== 0) creditCard.push(" "); // Add space
      creditCard.push(t);
    });
    return creditCard.join(""); // Transform card array to string
  };
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  const getSubLevel = async () => {
    let subResult = await checkSubscriptionLevel(
      user.signInUserSession.idToken.jwtToken
    ).then((subLevel) => subLevel);
    console.log("Sub Level Result:", subResult);
    let invoiceResult = await retrieveInvoices().then((res) => res);
    console.log("Invoice Result:", invoiceResult);
    let paymentResult = await checkPayMethod().then((res) => res);
    console.log("Payment Result:", paymentResult);
    setSubscriptionLevel(subResult);
    setDefaultPayment(paymentResult?.default_payment_method);
    setPaymentMethods(paymentResult?.data);
    setInvoices(invoiceResult);
    setSubscriptionLoading(false);
  };
  const cancelSub = async () => {
    let result = await cancelSubscription().then((res) => res);
    console.log("cancelSub Result:", result);
    await getSubLevel();
    setCancelLoading(false);
    setShowCancel(false);
  };
  const deleteCard = async () => {
    let result = await deletePayMethod(showDeleteCard.id).then((res) => res);
    console.log("deletePayMethod Result:", result);
    await getSubLevel();
    setDeleteCardLoading(false);
    setShowDeleteCard(false);
  };
  const makeDefault = async () => {
    let result = await setDefaultPM(tempDefaultPM).then((res) => res);
    console.log("setDefaultPM Result:", result);
    await getSubLevel();
    setMakeDefaultLoading(false);
  };
  const subscribe = async () => {
    let tierType;
    if (value == "Monthly") {
      tierType = "tier_one_monthly";
    } else if (value == "Yearly") {
      tierType = "tier_one_yearly";
    }
    let result = await createSubscription(tierType).then((res) => res);
    console.log("createSubscription Result:", result);
    await getSubLevel();
    setSubscribeLoading(false);
  };
  const saveCard = async () => {
    // Check errors
    let errors = { name: "", number: "", expiry: "", code: "", zip: "" };
    setCardCreateError("");
    if (cardName.length == 0) errors.name = "Required";
    if (cardNumber.length == 0) errors.number = "Required";
    if (
      (!cardNumber.startsWith(3) && cardNumber.length < 16) || //Card length
      (cardNumber.startsWith(3) && cardNumber.length < 15) || //Amex card length
      (!cardNumber.startsWith(4) && //Card type
        !cardNumber.startsWith(3) &&
        !cardNumber.startsWith(6) &&
        !cardNumber.startsWith(5))
    )
      errors.number = "Invalid";
    if (cardExpiry.length == 0) errors.expiry = "Required";
    if (cardExpiry.length < 5) errors.expiry = "Invalid";
    if (cardCode.length == 0) errors.code = "Required";
    if (
      (cardNumber.startsWith(3) && cardCode.length < 4) ||
      (!cardNumber.startsWith(3) && cardCode.length < 3)
    ) {
      errors.code = "Invalid";
    }
    if (cardZip.length == 0) errors.zip = "Required";
    if (cardZip.length < 5) errors.zip = "Invalid";
    //If Errors
    if (
      errors.name.length > 0 ||
      errors.number.length > 0 ||
      errors.expiry.length > 0 ||
      errors.code.length > 0 ||
      errors.zip.length > 0
    ) {
      setCardErrors(errors);
    } else {
      let cardObject = {
        type: "card",
        number: "",
        exp_month: null,
        exp_year: null,
        cvc: "",
      };
      // cardObject.name = cardName
      cardObject.number = cardNumber.split(" ").join("");
      cardObject.exp_month = Number(cardExpiry.split("/")[0]);
      cardObject.exp_year = Number("20" + cardExpiry.split("/")[1]);
      cardObject.cvc = cardCode;
      // cardObject.zip = cardZip
      console.log("Parsed Card Object:", cardObject);
      let result = await createPayMethod(cardObject).then((res) => res);
      console.log("createPayMethod Result:", result);
      if (result == true) {
        await getSubLevel();
        setCardName("");
        setCardNumber("");
        setCardExpiry("");
        setCardCode("");
        setCardZip("");
        setCardErrors({ name: "", number: "", expiry: "", code: "", zip: "" });
        setShowCardInput(false);
      } else {
        console.log("Error creating card:", result);
        try {
          if (_.has(result, "errors")) setCardCreateError(result.errors);
          if (_.has(result, "errorMessage"))
            setCardCreateError(result.errorMessage);
        } catch (error) {
          console.log("Unexpected Error", error);
          setCardCreateError("Unexpected error while adding card");
        }
      }
    }
    setSaveCardLoading(false);
  };
  useEffect(() => {
    if (subscriptionLoading) {
      try {
        getSubLevel();
      } catch (error) {
        console.log("checkSubscription ERROR:", error);
      }
    }
  }, [subscriptionLoading]);
  useEffect(() => {
    if (cancelLoading) {
      try {
        cancelSub();
      } catch (error) {
        console.log("cancelSub ERROR:", error);
      }
    }
  }, [cancelLoading]);
  useEffect(() => {
    if (deleteCardLoading) {
      try {
        deleteCard();
      } catch (error) {
        console.log("deleteCard ERROR:", error);
      }
    }
  }, [deleteCardLoading]);
  useEffect(() => {
    if (makeDefaultLoading) {
      try {
        makeDefault();
      } catch (error) {
        console.log("makeDefault ERROR:", error);
      }
    }
  }, [makeDefaultLoading]);
  useEffect(() => {
    if (saveCardLoading) {
      try {
        saveCard();
      } catch (error) {
        console.log("makeDefault ERROR:", error);
      }
    }
  }, [saveCardLoading]);
  useEffect(() => {
    if (subscribeLoading) {
      try {
        subscribe();
      } catch (error) {
        console.log("makeDefault ERROR:", error);
      }
    }
  }, [subscribeLoading]);
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 80px - 20px)",
        ...Metrics.horizontalPadding,
        ...Metrics.smallVerticalMargin,
        overflow: "auto",
      }}
    >
      <View style={{ ...Helpers.rowCross, justifyContent: "space-between" }}>
        <Text as="h3" weight={"regular"} color={"textPrimary"}>
          Manage Subscription
        </Text>
      </View>
      <Text as="body" weight={"regular"} color={"textSecondary"}>
        {"Add and edit payment method, and download invoices."}
      </Text>
      <Space h="md" />
      {subscriptionLoading ? (
        <Center>
          <Loader color={Colors.main} />
        </Center>
      ) : Array.isArray(subscriptionLevel) ? (
        <Paper p="md">
          <View
            style={{
              ...Helpers.rowCross,
              justifyContent: "space-between",
              borderBottom: "1px solid",
              borderBottomColor: Colors.lineDivider,
              ...Metrics.smallVerticalPadding,
              marginBottom: Spacing.sm,
            }}
          >
            <Text as="headline" weight={"regular"} color={"textPrimary"}>
              {"Subscription"}
            </Text>
            {subscriptionLevel[0]?.plan?.active ? (
              <Button
                text="Cancel Subscription"
                variant="error"
                onPress={async () => {
                  setShowCancel(true);
                }}
              />
            ) : (
              <Button
                text="Subscribe"
                isLoading={subscribeLoading}
                variant="primary-transparent"
                onPress={async () => {
                  if (defaultPayment) {
                    setSubscribeLoading(true);
                  } else {
                    setShowPaymentError(true);
                  }
                }}
              />
            )}
          </View>
          <View style={{ width: "100%", ...Helpers.row }}>
            <View style={{ ...Helpers.fillCol }}>
              <Text as="body" weight={"bold"} color={"textPrimary"}>
                {"Status"}
              </Text>
              <Text as="body" weight={"bold"} color={"textPrimary"}>
                {"Billing Frequency"}
              </Text>
              <Text as="body" weight={"bold"} color={"textPrimary"}>
                {"Next Billing Date"}
              </Text>
            </View>
            <View style={{ ...Helpers.fillCol }}>
              <Text as="body" weight={"regular"} color={"textPrimary"}>
                {subscriptionLevel[0]?.plan?.active ? "Active" : "Inactive"}
              </Text>
              <Text as="body" weight={"regular"} color={"textPrimary"}>
                {subscriptionLevel[0]?.plan?.id == monthlyPlan
                  ? "Monthly"
                  : subscriptionLevel[0]?.plan?.id == yearlyPlan
                  ? "Annually"
                  : "N/A"}
              </Text>
              <Text as="body" weight={"regular"} color={"textPrimary"}>
                {subscriptionLevel[0]?.current_period_end
                  ? new Date(
                      subscriptionLevel[0].current_period_end * 1000
                    ).toLocaleDateString(undefined, {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : "N/A"}
              </Text>
            </View>
          </View>
          <View
            style={{
              ...Helpers.rowCross,
              justifyContent: "space-between",
              borderBottom: "1px solid",
              borderBottomColor: Colors.lineDivider,
              ...Metrics.smallVerticalPadding,
              marginBottom: Spacing.sm,
            }}
          >
            <Text as="headline" weight={"regular"} color={"textPrimary"}>
              {"Payment Methods"}
            </Text>
          </View>
          <View style={Helpers.row}>
            <View style={{ width: "50%" }}>
              <Text color={"darkGrey"} weight={"medium"} as={"subtitle"}>
                {"Default Payment Method"}
              </Text>
              {paymentMethods && paymentMethods.length > 0 && (
                <View
                  style={{
                    ...Helpers.rowCross,
                    height: 40,
                    ...Metrics.smallVerticalPadding,
                    overflow: "hidden",
                  }}
                >
                  <img
                    style={{ width: 50, marginRight: Spacing.sm }}
                    src={
                      paymentMethods[0].card.brand == "visa" ? (
                        Images.visa
                      ) : paymentMethods[0].card.brand == "amex" ? (
                        Images.amex
                      ) : paymentMethods[0].card.brand == "discover" ? (
                        Images.discover
                      ) : paymentMethods[0].card.brand == "mastercard" ? (
                        Images.mastercard
                      ) : (
                        <></>
                      )
                    }
                    resizeMode={"contain"}
                  />
                  <View
                    style={[
                      Helpers.rowCross,
                      { paddingLeft: Spacing.sm, width: 200 },
                    ]}
                  >
                    <Text color={"darkGrey"} weight={"medium"} as={"subtitle"}>
                      {"**** **** **** " +
                        paymentMethods[0].card.last4 +
                        "  " +
                        paymentMethods[0].card.exp_month +
                        "/" +
                        (paymentMethods[0].card.exp_year % 100)}
                    </Text>
                  </View>
                  <Button
                    style={{
                      width: "32px",
                      borderRadius: "5px",
                      height: "32px",
                      ...Metrics.tinyHorizontalMargin,
                    }}
                    variant={"error"}
                    icon={{ icon: trashIcon, size: "xs", color: Colors.white }}
                    onPress={() => {
                      setShowDeleteCard(paymentMethods[0]);
                    }}
                  />
                </View>
              )}
            </View>
            <View style={{ width: "50%" }}>
              <Text color={"darkGrey"} weight={"medium"} as={"subtitle"}>
                {"Other Payment Methods"}
              </Text>
              {paymentMethods && paymentMethods.length > 0 ? (
                paymentMethods.map((item, index) =>
                  index > 0 ? (
                    <View
                      style={{
                        ...Helpers.rowCross,
                        height: 40,
                        ...Metrics.smallVerticalPadding,
                        overflow: "hidden",
                      }}
                    >
                      <img
                        style={{ width: 50, marginRight: Spacing.sm }}
                        src={
                          item.card.brand == "visa" ? (
                            Images.visa
                          ) : item.card.brand == "amex" ? (
                            Images.amex
                          ) : item.card.brand == "discover" ? (
                            Images.discover
                          ) : item.card.brand == "mastercard" ? (
                            Images.mastercard
                          ) : (
                            <></>
                          )
                        }
                        resizeMode={"contain"}
                      />
                      <View
                        style={[
                          Helpers.rowCross,
                          { paddingLeft: Spacing.sm, width: 200 },
                        ]}
                      >
                        <Text
                          color={"darkGrey"}
                          weight={"medium"}
                          as={"subtitle"}
                        >
                          {"**** **** **** " +
                            item.card.last4 +
                            "  " +
                            item.card.exp_month +
                            "/" +
                            (item.card.exp_year % 100)}
                        </Text>
                      </View>
                      <Button
                        style={{
                          width: "32px",
                          borderRadius: "5px",
                          height: "32px",
                          ...Metrics.tinyHorizontalMargin,
                        }}
                        variant={"error"}
                        icon={{
                          icon: trashIcon,
                          size: "xs",
                          color: Colors.white,
                        }}
                        onPress={() => {
                          setShowDeleteCard(item);
                        }}
                      />
                      <Button
                        style={{
                          height: 32,
                          ...Metrics.horizontalPadding,
                          ...Metrics.tinyHorizontalMargin,
                        }}
                        isLoading={
                          makeDefaultLoading && tempDefaultPM == item.id
                        }
                        text="Make Default"
                        variant="primary-transparent"
                        onPress={async () => {
                          tempDefaultPM = item.id;
                          setMakeDefaultLoading(true);
                        }}
                      />
                    </View>
                  ) : (
                    <></>
                  )
                )
              ) : (
                <Text style={Metrics.smallVerticalMargin} color={"darkGrey"}>
                  {"There are no credit cards associated with this account."}
                </Text>
              )}
              {showCardInput ? (
                <></>
              ) : (
                <Button
                  style={{
                    height: 32,
                    ...Metrics.horizontalPadding,
                    ...Metrics.tinyHorizontalMargin,
                  }}
                  text="Add Card"
                  variant="white"
                  onPress={async () => {
                    setShowCardInput(true);
                  }}
                />
              )}
            </View>
          </View>
          {showCardInput ? (
            <View
              style={[
                Helpers.column,
                Metrics.smallHorizontalMargin,
                Metrics.verticalMargin,
              ]}
            >
              <View style={[Helpers.colCenter]}>
                <img
                  style={{ width: "70%", margin: Spacing.sm }}
                  src={Images.cards}
                />
              </View>
              <Text
                style={{ paddingLeft: Spacing.sm }}
                as="medium"
                color="darkGrey"
                weight="light"
              >
                {"Name on Card"}
              </Text>
              <Input
                style={{
                  textAlign: "left",
                  color: Colors.darkGrey,
                  paddingLeft: 10,
                  ...Fonts.medium,
                  fontFamily: "Inter-Regular",
                  flex: 1,
                  overflow: "hidden",
                }} //medium
                value={cardName}
                placeholder={cardErrors.name.length > 0 ? "Required" : ""}
                status={cardErrors.name.length > 0 ? "error" : ""}
                onChange={(event) => {
                  if (cardErrors.name.length > 0)
                    setCardErrors({ ...cardErrors, name: "" });
                  setCardName(event.target.value);
                }}
              />
              <Text
                style={{ paddingLeft: Spacing.sm }}
                as="medium"
                color="darkGrey"
                weight="light"
              >
                {"Card Number"}
              </Text>
              <Input
                style={{
                  textAlign: "left",
                  color: Colors.darkGrey,
                  paddingLeft: 10,
                  ...Fonts.medium,
                  fontFamily: "Inter-Regular",
                  flex: 1,
                  overflow: "none",
                }} //medium
                value={handleCardDisplay()}
                placeholder={cardErrors.number.length > 0 ? "Required" : ""}
                status={cardErrors.number.length > 0 ? "error" : ""}
                onChange={(event) => {
                  console.log("Number Edit Event:", event);
                  let targetValue;
                  if (cardErrors.number.length > 0)
                    setCardErrors({ ...cardErrors, number: "" });
                  if (event?.nativeEvent?.inputType == "insertText") {
                    if (
                      !isNaN(Number(event?.nativeEvent?.data)) &&
                      event?.nativeEvent?.data != " "
                    )
                      targetValue = event.target.value;
                  } else if (
                    event?.nativeEvent?.inputType == "insertFromPaste"
                  ) {
                    let pastedText = event?.target?.value.split(" ").join("");
                    if (!isNaN(Number(pastedText)) && pastedText != " ")
                      targetValue = pastedText;
                  } else {
                    targetValue = event.target.value;
                  }
                  if (targetValue != undefined) {
                    console.log("Target Value:", targetValue);
                    targetValue = targetValue.split(" ").join("");
                    if (cardNumber.startsWith(3)) {
                      //Amex
                      if (targetValue.length > 15)
                        targetValue = targetValue.slice(0, 15);
                    } else if (targetValue.length > 16) {
                      targetValue = targetValue.slice(0, 16);
                    }
                    return setCardNumber(targetValue);
                  }
                  return;
                }}
                suffix={
                  <View
                    style={{
                      ...Helpers.center,
                      height: 35,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      style={{
                        height: cardNumber.startsWith(4)
                          ? 20
                          : cardNumber.startsWith(3)
                          ? 60
                          : cardNumber.startsWith(6)
                          ? 30
                          : 40,
                        margin: Spacing.sm,
                      }}
                      src={
                        cardNumber.startsWith(4)
                          ? Images.visa
                          : cardNumber.startsWith(3)
                          ? Images.amex
                          : cardNumber.startsWith(6)
                          ? Images.discover
                          : cardNumber.startsWith(5)
                          ? Images.mastercard
                          : null
                      }
                      resizeMode={""}
                    />
                  </View>
                }
              />
              <Space.Compact style={{ ...Helpers.fillRow }}>
                <View style={{ ...Helpers.fillCol }}>
                  <Text
                    style={{ paddingLeft: Spacing.sm }}
                    as="medium"
                    color="darkGrey"
                    weight="light"
                  >
                    {"Expiry Date"}
                  </Text>
                  <Input
                    style={{
                      textAlign: "left",
                      color: Colors.darkGrey,
                      paddingLeft: 10,
                      ...Fonts.medium,
                      fontFamily: "Inter-Regular",
                      flex: 1,
                      overflow: "hidden",
                    }} //medium
                    value={cardExpiry}
                    placeholder={
                      cardErrors.expiry.length > 0 ? "Required" : "MM/YY"
                    }
                    status={cardErrors.expiry.length > 0 ? "error" : ""}
                    onChange={(event) => {
                      console.log("Value:", event);
                      if (cardErrors.expiry.length > 0)
                        setCardErrors({ ...cardErrors, expiry: "" });
                      let targetValue;
                      if (
                        event?.nativeEvent?.inputType == "deleteContentBackward"
                      ) {
                        if (event.target.value.length == 2) {
                          targetValue = event.target.value.slice(0, 1);
                        } else {
                          targetValue = event.target.value;
                        }
                      } else if (
                        event?.nativeEvent?.inputType == "insertText"
                      ) {
                        if (
                          !isNaN(Number(event?.nativeEvent?.data)) &&
                          event?.nativeEvent?.data != " "
                        ) {
                          if (event.target.value.length == 2) {
                            targetValue = event.target.value + "/";
                          } else {
                            targetValue = event.target.value;
                          }
                        }
                      } else if (
                        event?.nativeEvent?.inputType == "insertFromPaste"
                      ) {
                        let pastedText = event?.target?.value
                          .split("/")
                          .join("");
                        if (!isNaN(Number(pastedText)) && pastedText != " ") {
                          targetValue = pastedText;
                          if (pastedText.length == 2) {
                            targetValue = pastedText + "/";
                          } else if (pastedText.length > 2) {
                            targetValue =
                              pastedText.slice(0, 2) +
                              "/" +
                              pastedText.slice(2);
                          } else {
                            targetValue = pastedText;
                          }
                        }
                      } else {
                        targetValue = event.target.value;
                      }
                      if (targetValue != undefined) {
                        if (targetValue.length > 5) {
                          targetValue = targetValue.slice(0, 5);
                        }
                        return setCardExpiry(targetValue);
                      }
                      return;
                    }}
                  />
                </View>
                <View style={{ ...Helpers.fillCol, overflow: "hidden" }}>
                  <Text
                    style={{ paddingLeft: Spacing.sm }}
                    as="medium"
                    color="darkGrey"
                    weight="light"
                  >
                    {"Security Code"}
                  </Text>
                  <Input
                    style={{
                      textAlign: "left",
                      color: Colors.darkGrey,
                      paddingLeft: 10,
                      ...Fonts.medium,
                      fontFamily: "Inter-Regular",
                      flex: 1,
                      overflow: "hidden",
                    }} //medium
                    value={cardCode}
                    placeholder={cardErrors.code.length > 0 ? "Required" : ""}
                    status={cardErrors.code.length > 0 ? "error" : ""}
                    onChange={(event) => {
                      if (cardErrors.code.length > 0)
                        setCardErrors({ ...cardErrors, code: "" });
                      let targetValue;
                      if (
                        event?.nativeEvent?.inputType == "deleteContentBackward"
                      ) {
                        targetValue = event.target.value;
                      } else if (
                        event?.nativeEvent?.inputType == "insertText" &&
                        !isNaN(Number(event?.nativeEvent?.data)) &&
                        event?.nativeEvent?.data != " "
                      ) {
                        targetValue = event.target.value;
                      } else if (
                        event?.nativeEvent?.inputType == "insertFromPaste"
                      ) {
                        if (!isNaN(Number(event?.target?.value)))
                          targetValue = event.target.value;
                      } else {
                        targetValue = event.target.value;
                      }
                      if (targetValue != undefined) {
                        if (cardNumber.startsWith(3)) {
                          if (targetValue.length > 4)
                            targetValue = targetValue.slice(0, 4);
                        } else if (targetValue.length > 3) {
                          targetValue = targetValue.slice(0, 3);
                        }
                        return setCardCode(targetValue);
                      }
                      return;
                    }}
                    suffix={
                      <Popover
                        open={open}
                        color={Colors.darkGrey}
                        content={
                          cardNumber.startsWith(3) ? (
                            <View>
                              <Text color={"white"}>
                                {"The 4 digits on the front of your card."}
                              </Text>
                              <View
                                style={{
                                  ...Helpers.row,
                                  justifyContent: "space-around",
                                  marginTop: Spacing.sm,
                                }}
                              >
                                <img height={100} src={Images.amexCVV} />
                              </View>
                            </View>
                          ) : cardNumber.startsWith(4) ||
                            cardNumber.startsWith(6) ||
                            cardNumber.startsWith(5) ? (
                            <View>
                              <Text color={"white"}>
                                {"The 3 digits on the back of your card."}
                              </Text>
                              <View
                                style={{
                                  ...Helpers.row,
                                  justifyContent: "space-around",
                                  marginTop: Spacing.sm,
                                }}
                              >
                                <img height={100} src={Images.cardCVV} />
                              </View>
                            </View>
                          ) : (
                            <View>
                              <Text color={"white"}>
                                {
                                  "For Visa, MasterCard, or Discover, the 3 digits on the back of your card.\n\nFor American Express, the 4 digits on the front of your card."
                                }
                              </Text>
                              <View
                                style={{
                                  ...Helpers.row,
                                  justifyContent: "space-around",
                                  marginTop: Spacing.sm,
                                }}
                              >
                                <img height={100} src={Images.cardCVV} />
                                <img height={100} src={Images.amexCVV} />
                              </View>
                            </View>
                          )
                        }
                        arrow={{ pointAtCenter: true }}
                        placement="topRight"
                      >
                        <QuestionCircleFilled
                          onMouseEnter={() => setOpen(true)}
                          onMouseLeave={() => setOpen(false)}
                          ref={cvcRef}
                          style={{
                            ...Helpers.center,
                            height: 28,
                            color: Colors.lightGrey,
                          }}
                        />
                      </Popover>
                    }
                  />
                </View>
              </Space.Compact>
              <Text
                style={{ paddingLeft: Spacing.sm }}
                as="medium"
                color="darkGrey"
                weight="light"
              >
                {"ZIP/Postal Code"}
              </Text>
              <Input
                style={{
                  textAlign: "left",
                  color: Colors.darkGrey,
                  paddingLeft: 10,
                  ...Fonts.medium,
                  fontFamily: "Inter-Regular",
                  flex: 1,
                  overflow: "hidden",
                }} //medium
                value={cardZip}
                placeholder={cardErrors.zip.length > 0 ? "Required" : ""}
                status={cardErrors.zip.length > 0 ? "error" : ""}
                onChange={(event) => {
                  let targetValue;
                  if (cardErrors.zip.length > 0)
                    setCardErrors({ ...cardErrors, zip: "" });
                  if (
                    event?.nativeEvent?.inputType == "deleteContentBackward"
                  ) {
                    targetValue = event.target.value;
                  } else if (
                    event?.nativeEvent?.inputType == "insertText" &&
                    !isNaN(Number(event?.nativeEvent?.data)) &&
                    event?.nativeEvent?.data != " "
                  ) {
                    targetValue = event.target.value;
                  } else if (
                    event?.nativeEvent?.inputType == "insertFromPaste"
                  ) {
                    if (!isNaN(Number(event?.target?.value)))
                      targetValue = event.target.value;
                  } else {
                    targetValue = event.target.value;
                  }

                  if (targetValue != undefined) {
                    if (targetValue.length > 5) {
                      targetValue = targetValue.slice(0, 5);
                    }
                    return setCardZip(targetValue);
                  }
                  return;
                }}
                suffix={
                  <Tooltip
                    color={Colors.darkGrey}
                    title="Enter the ZIP/Postal code for your credit card's billing address."
                    arrow={{ pointAtCenter: true }}
                    placement="topRight"
                  >
                    <QuestionCircleFilled style={{ color: Colors.lightGrey }} />
                  </Tooltip>
                }
              />
              <Text as={"small"} color={"error"}>
                {cardCreateError}
              </Text>
              <View style={[Helpers.rowCross]}>
                <Button
                  style={[Metrics.horizontalPadding, Metrics.smallTopMargin]}
                  disabled={saveCardLoading}
                  text="Cancel"
                  variant="primary-transparent"
                  onPress={async () => {
                    setCardName("");
                    setCardNumber("");
                    setCardExpiry("");
                    setCardCode("");
                    setCardZip("");
                    setCardErrors({
                      name: "",
                      number: "",
                      expiry: "",
                      code: "",
                      zip: "",
                    });
                    setShowCardInput(false);
                  }}
                />
                <Button
                  style={[Metrics.horizontalPadding, Metrics.smallTopMargin]}
                  text="Save Card"
                  isLoading={saveCardLoading}
                  variant="primary"
                  onPress={async () => {
                    setSaveCardLoading(true);
                  }}
                />
              </View>
            </View>
          ) : (
            <></>
          )}
          <View
            style={{
              ...Helpers.rowCross,
              justifyContent: "space-between",
              borderBottom: "1px solid",
              borderBottomColor: Colors.lineDivider,
              ...Metrics.smallVerticalPadding,
              marginBottom: Spacing.sm,
            }}
          >
            <Text as="headline" weight={"regular"} color={"textPrimary"}>
              {"Invoices"}
            </Text>
          </View>
          {invoices && invoices.length > 0 ? (
            <Table
              columns={invoiceColumns}
              dataSource={invoices}
              sticky={true}
            />
          ) : (
            <Text style={Metrics.smallVerticalMargin} color={"darkGrey"}>
              {"There are no invoices associated with this account."}
            </Text>
          )}
        </Paper>
      ) : (
        <></>
      )}
      <Alert
        visible={showCancel}
        loading={cancelLoading}
        setVisible={setShowCancel}
        title="Cancel Subscription"
        text={"Are you sure you want to cancel your Stratus Plus subscription?"}
        onPress={() => {
          setCancelLoading(true);
        }}
      />
      <Alert
        visible={showDeleteCard}
        loading={deleteCardLoading}
        setVisible={setShowDeleteCard}
        title="Delete Card"
        text={`Are you sure you want to delete your ${
          showDeleteCard?.card?.brand.charAt(0).toUpperCase() +
          showDeleteCard?.card?.brand.slice(1)
        } card ending with ${showDeleteCard?.card?.last4}`}
        onPress={() => {
          setDeleteCardLoading(true);
        }}
      />
      <Alert
        visible={showPaymentError}
        setVisible={setShowPaymentError}
        title="No Default Payment"
        text={
          "Please add a default payment method before subscribing to Stratus Pro."
        }
        oneButton={true}
        onPress={() => {
          setSubNav("payment");
          setShowPaymentError(false);
        }}
      />
    </View>
  );
}

export default Reports;
